
import React from 'react';
import { CandidateTableSkeleton } from '@/components/skeletons/TableSkeleton';

interface EnhancedLoadingStateProps {
  loading: boolean;
  dataLoadError: string | null;
  children: React.ReactNode;
  stage?: 'permissions' | 'data';
}

const EnhancedLoadingState: React.FC<EnhancedLoadingStateProps> = ({
  loading,
  dataLoadError,
  children
}) => {
  if (dataLoadError) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="text-center p-8">
          <div className="w-16 h-16 bg-destructive/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <div className="w-8 h-8 bg-destructive rounded-full"></div>
          </div>
          <h2 className="text-xl font-semibold text-foreground mb-2">Something went wrong</h2>
          <p className="text-muted-foreground mb-4">
            {dataLoadError}
          </p>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-background">
        <CandidateTableSkeleton />
      </div>
    );
  }

  return <>{children}</>;
};

export default EnhancedLoadingState;
